import { useTheme } from 'styled-components'

/**
 * See `formatDimensions` for more information on the shape
 */
export const useDimensions = () => useTheme().dimensions
